module.exports = __webpack_public_path__ + "static/img/choose-dermatology-01.f7f2da8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/choose-dermatology-01.jpg
// module id = 252
// module chunks = 1